<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button color="primary" (click)="closeModal()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-card class="ion-no-margin">
    <ion-card-content>
      <ion-row>
        <ion-col>
          <ion-list class="ion-no-margin">
              <ods-single-select
                class="fullwidth"
                [isTenantSelection]="true"
              />
              @if (!this.deploymentStore.deploymentIsLoading()) {
                <ods-single-select
                  class="fullwidth"
                  [isTenantSelection]="false"
                />
              } @else {
                <ods-loader class="ods-spinner-medium" />
              }
          </ion-list>
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</ion-content>
